import React, { Component } from 'react'
import { connect } from 'react-redux'
import { apiFetch } from 'helpers'
import styled from 'styled-components'
import NavBar from 'components/NavBar'
import { FormGroup, Label, Input, Button, ErrorText } from 'components/Form'

@connect()
export default class extends Component {
  constructor (props) {
    super(props)
    this.state = {
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    }
  }

  _onChangePassword = () => {
    let errors = {
      currentPasswordError: this.state.currentPassword ? '' : 'จำเป็นต้องกรอกข้อมูล',
      newPasswordError: this.state.newPassword ? '' : 'จำเป็นต้องกรอกข้อมูล',
      confirmPasswordError: this.state.confirmPassword ? '' : 'จำเป็นต้องกรอกข้อมูล'
    }
    if (this.state.newPassword && this.state.confirmPassword && this.state.newPassword !== this.state.confirmPassword) {
      errors.newPasswordError = 'รหัสผ่านทั้งสองไม่ตรงกัน'
      errors.confirmPasswordError = 'รหัสผ่านทั้งสองไม่ตรงกัน'
    }
    if (Object.keys(errors).some(key => errors[key])) return this.setState(errors)
    this.setState({ ...errors, submitting: true }, () =>
      apiFetch({
        method: 'POST',
        v4: true,
        url: '/v4/vendors/change-password',
        body: {
          currentPassword: this.state.currentPassword,
          newPassword: this.state.newPassword
        }
      })
        .then(result => {
          this.props.dispatch({ type: 'SEND_MESSAGE', messageType: 'success', message: 'เปลี่ยนรหัสผ่านสำเร็จ' })
          this.props.history.replace('/settings')
          this.setState({ submitting: false })
        })
        .catch(error => {
          const message = error.reason === 'Current password is incorrect.'
            ? 'รหัสผ่านปัจจุบันไม่ถูกต้อง'
            : 'เปลี่ยนรหัสผ่านไม่สำเร็จ, กรุณาลองใหม่อีกครั้ง'
          this.props.dispatch({
            type: 'SEND_MESSAGE',
            messageType: 'error',
            message
          })
          this.setState({ error, submitting: false })
        })
    )
  }

  render () {
    const { history } = this.props
    return (
      <Container>
        <NavBar onBack={() => history.replace('/settings')} backTitle='ตั้งค่า' title='เปลี่ยนรหัสผ่าน' />
        <Body>
          <FormGroup>
            <Label required>รหัสผ่านปัจจุบัน</Label>
            {this.state.currentPasswordError && <ErrorText>{this.state.currentPasswordError}</ErrorText>}
            <Input type='password' value={this.state.currentPassword}
              onChange={e => this.setState({ currentPassword: e.target.value })} />
          </FormGroup>
          <FormGroup>
            <Label required>รหัสผ่านใหม่</Label>
            {this.state.newPasswordError && <ErrorText>{this.state.newPasswordError}</ErrorText>}
            <Input type='password' value={this.state.newPassword}
              onChange={e => this.setState({ newPassword: e.target.value })} />
          </FormGroup>
          <FormGroup>
            <Label required>ยืนยันรหัสผ่านใหม่</Label>
            {this.state.confirmPasswordError && <ErrorText>{this.state.confirmPasswordError}</ErrorText>}
            <Input type='password' value={this.state.confirmPassword}
              onChange={e => this.setState({ confirmPassword: e.target.value })} />
          </FormGroup>
          <Button loading={this.state.submitting} style={{ marginTop: 30 }} onClick={this._onChangePassword}>เปลี่ยนรหัสผ่าน</Button>
        </Body>
      </Container>
    )
  }
}

const Container = styled.section`

`
const Body = styled.div`
  padding: 15px;
`



// WEBPACK FOOTER //
// ./src/containers/ChangePassword.js